import React from 'react';
import $ from 'jquery';
import { cleanEnquiry } from '../../../store/User/userActions';
import { connect } from 'react-redux';

const ConfirmModal = ({ cleanEnquiry }) => {
  const handleConfirm = () => {
    cleanEnquiry();
    $('#ConfirmModal').modal('hide');
  };

  return (
    <div
      className='modal'
      id='ConfirmModal'
      role='dialog'
      data-backdrop='static'
      data-keyboard='false'
    >
      <div
        className='modal-dialog modal-dialog-centered modal-md'
        role='document'
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h4 className='m-0'>Confirmation</h4>
          </div>
          <div className='modal-body'>
            <p>
              <b>Thank you for your enquiry.</b>
            </p>
            <p>
              <b>
                We will be in touch shortly to discuss your requirements and
                design the optimum RegulationCity subscription package for your
                organisation.
              </b>
            </p>
          </div>
          <div className='modal-footer d-flex justify-content-center py-0'>
            <button
              className='my-account-btn'
              data-dismiss='modal'
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = { cleanEnquiry };

const connector = connect(null, mapDispatchToProps);

export default connector(ConfirmModal);
